import styles from "./Messaging.module.css";

import IconAndName from "../../components/IconAndName/IconAndName";

import { FaUserPlus, FaUpload, FaInfoCircle } from "react-icons/fa";
import { useState } from "react";

import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";

import CopyRight from "../../components/CopyRight/CopyRight";
import MessagingSection from "../../sections/MessagingSection/MessagingSection";

const Messaging = () => {


  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("Direct");

  const tab = [
    {
      label: "Direct",
      content: <MessagingSection type="direct" />, // 👈 add this
    },
    {
      label: "Groups",
      content: <MessagingSection type="group" />, // 👈 add this
    },
  ];
  

  return (
    <>
      <div className={styles.StudentSection}>
        <div className={styles.maincontainer}>
          <div className={styles.container}>
            {/* <TabSwitch tabs={tab} /> */}
            {tab.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`${styles.tabOptions} ${
                    activeTab === item.label && styles.ActivetabOption
                  }`}
                  onClick={() => setActiveTab(item.label)}
                >
                  {item.label}
                </div>
              );
            })}
          </div>
          {activeTab === "Direct" && (
            <div className={styles.infoText}>
              <FaInfoCircle className={styles.infoIcon} />
              <span>Any staff can respond to parent message</span>
            </div>
          )}
        </div>
        {tab.map((item) =>
          activeTab === item.label ? <>{item.content}</> : null
        )}
      </div>
      <div>{activeTab === "Direct" && <CopyRight />}</div>
    </>
  );
};

export default Messaging;
